// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"23":"interaction-areas","311":"recommendations-overlay","436":"chapters","449":"playlist","698":"ima","990":"shoppable"}[chunkId] + ".min.css";
};